import React from "react";
import { colors } from "../../../global";

const StagePerformanceCards = ({ data }) => {
  const { rows = [], title = "" } = data || {};
  if (!rows.length) return null;

  const regularRows = rows.filter((item) => item.stage !== "TOTAL");
  const totalRow = rows.find((item) => item.stage === "TOTAL");

  return (
    <div className="w-full">
      {/* HEADER */}
      <div className="mb-6">
        <h2 className="text-2xl font-bold" style={{ color: colors.primary }}>
          {title.split("\n").map((line, i) => (
            <React.Fragment key={i}>
              {line}
              {i === 0 && <br />}
            </React.Fragment>
          ))}
        </h2>
      </div>

      {/* ALL CARDS IN 3 COLUMN GRID */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {regularRows.map((item, index) => {
          const isMeetingTarget = item.remaining_hours >= 0;

          return (
            <div
              key={index}
              className="bg-white rounded-xl p-5 border border-gray-200 transition-all duration-200 hover:shadow-lg"
            >
              {/* HEADER */}
              <div className="flex items-start justify-between mb-4">
                <div className="flex items-center gap-3">
                  <div
                    className="w-11 h-11 rounded-lg flex items-center justify-center text-white text-sm font-bold shadow-sm"
                    style={{ backgroundColor: colors.primary }}
                  >
                    {item.stage
                      .split(" ")
                      .map((w) => w[0])
                      .join("")}
                  </div>

                  <div>
                    <h3
                      className="text-sm font-bold leading-tight"
                      style={{ color: colors.primary }}
                    >
                      {item.stage}
                    </h3>
                  </div>
                </div>

                {/* STATUS BADGE */}
                <div
                  className={`px-2 py-1 rounded-full flex items-center gap-1 ${
                    isMeetingTarget ? "bg-green-50" : "bg-red-50"
                  }`}
                >
                  <svg
                    className={`w-3.5 h-3.5 ${
                      isMeetingTarget ? "text-green-600" : "text-red-600"
                    }`}
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    {isMeetingTarget ? (
                      <path
                        fillRule="evenodd"
                        d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                        clipRule="evenodd"
                      />
                    ) : (
                      <path
                        fillRule="evenodd"
                        d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
                        clipRule="evenodd"
                      />
                    )}
                  </svg>
                </div>
              </div>

              {/* METRICS GRID */}
              <div className="grid grid-cols-2 gap-3 mb-4">
                <div>
                  <p
                    className="text-xs font-medium mb-1"
                    style={{ color: colors.secondary }}
                  >
                    Average Time
                  </p>
                  <p
                    className="text-xl font-bold"
                    style={{ color: colors.primary }}
                  >
                    {item.average}
                    <span className="text-sm font-normal">h</span>
                  </p>
                </div>

                <div>
                  <p
                    className="text-xs font-medium mb-1"
                    style={{ color: colors.secondary }}
                  >
                    Target Time
                  </p>
                  <p
                    className="text-xl font-bold"
                    style={{ color: colors.primary }}
                  >
                    {item.target}
                    <span className="text-sm font-normal">h</span>
                  </p>
                </div>
              </div>

              {/* REMAINING TIME */}
              <div className="pt-4 border-t border-gray-200">
                <div className="flex items-baseline justify-between mb-2">
                  <span
                    className="text-xs font-medium"
                    style={{ color: colors.secondary }}
                  >
                    Remaining Time
                  </span>

                  <span
                    className="text-2xl font-bold"
                    style={{
                      color: isMeetingTarget ? "#22c55e" : colors.accent,
                    }}
                  >
                    {item.remaining_hours > 0 ? "+" : ""}
                    {item.remaining_hours}
                    <span className="text-sm font-normal">h</span>
                  </span>
                </div>

                {/* Progress Bar */}
                <div className="relative">
                  <div className="w-full bg-gray-200 rounded-full h-2.5 overflow-hidden">
                    <div
                      className="h-2.5 rounded-full transition-all duration-500"
                      style={{
                        width: `${Math.min(
                          (item.average / item.target) * 100,
                          100
                        )}%`,
                        backgroundColor: isMeetingTarget
                          ? "#22c55e"
                          : colors.accent,
                      }}
                    />
                  </div>

                  {!isMeetingTarget && item.average > item.target && (
                    <div
                      className="absolute top-0 bottom-0 w-0.5 bg-gray-400"
                      style={{ left: `${(item.target / item.average) * 100}%` }}
                    >
                      <div className="absolute -top-1 -left-1 w-2 h-2 rounded-full bg-gray-400" />
                    </div>
                  )}
                </div>
              </div>
            </div>
          );
        })}

        {/* TOTAL CARD - DALAM GRID YANG SAMA */}
        {totalRow && (
          <div
            className="bg-white rounded-xl p-5 border-2 shadow-lg lg:col-span-3"
            style={{
              borderColor: colors.primary,
              backgroundColor: colors.gray,
            }}
          >
            {/* HEADER */}
            <div className="flex items-start justify-between mb-4">
              <div className="flex items-center gap-3">
                <div
                  className="w-11 h-11 rounded-lg flex items-center justify-center text-white text-base font-bold shadow-sm"
                  style={{ backgroundColor: colors.primary }}
                >
                  T
                </div>

                <div>
                  <h3
                    className="text-sm font-bold leading-tight"
                    style={{ color: colors.primary }}
                  >
                    {totalRow.stage}
                  </h3>
                  <span
                    className="text-xs font-medium"
                    style={{ color: colors.secondary }}
                  >
                    Overall Summary
                  </span>
                </div>
              </div>

              {/* STATUS BADGE */}
              <div
                className={`px-2 py-1 rounded-full flex items-center gap-1 ${
                  totalRow.remaining_hours >= 0 ? "bg-green-50" : "bg-red-50"
                }`}
              >
                <svg
                  className={`w-3.5 h-3.5 ${
                    totalRow.remaining_hours >= 0
                      ? "text-green-600"
                      : "text-red-600"
                  }`}
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  {totalRow.remaining_hours >= 0 ? (
                    <path
                      fillRule="evenodd"
                      d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                      clipRule="evenodd"
                    />
                  ) : (
                    <path
                      fillRule="evenodd"
                      d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
                      clipRule="evenodd"
                    />
                  )}
                </svg>
              </div>
            </div>

            {/* METRICS GRID - 3 COLUMNS */}
            <div className="grid grid-cols-3 gap-3 mb-4">
              <div>
                <p
                  className="text-xs font-medium mb-1"
                  style={{ color: colors.secondary }}
                >
                  Average Time
                </p>
                <p
                  className="text-xl font-bold"
                  style={{ color: colors.primary }}
                >
                  {totalRow.average}
                  <span className="text-sm font-normal">h</span>
                </p>
              </div>

              <div>
                <p
                  className="text-xs font-medium mb-1"
                  style={{ color: colors.secondary }}
                >
                  Target Time
                </p>
                <p
                  className="text-xl font-bold"
                  style={{ color: colors.primary }}
                >
                  {totalRow.target}
                  <span className="text-sm font-normal">h</span>
                </p>
              </div>

              <div>
                <p
                  className="text-xs font-medium mb-1"
                  style={{ color: colors.secondary }}
                >
                  Remaining Time
                </p>
                <p
                  className="text-xl font-bold"
                  style={{
                    color:
                      totalRow.remaining_hours >= 0 ? "#22c55e" : colors.accent,
                  }}
                >
                  {totalRow.remaining_hours > 0 ? "+" : ""}
                  {totalRow.remaining_hours}
                  <span className="text-sm font-normal">h</span>
                </p>
              </div>
            </div>

            {/* PROGRESS BAR */}
            <div className="pt-4 border-t border-gray-300">
              <div className="relative">
                <div className="w-full bg-gray-300 rounded-full h-2.5 overflow-hidden">
                  <div
                    className="h-2.5 rounded-full transition-all duration-500"
                    style={{
                      width: `${Math.min(
                        (totalRow.average / totalRow.target) * 100,
                        100
                      )}%`,
                      backgroundColor:
                        totalRow.remaining_hours >= 0
                          ? "#22c55e"
                          : colors.accent,
                    }}
                  />
                </div>

                {totalRow.remaining_hours < 0 &&
                  totalRow.average > totalRow.target && (
                    <div
                      className="absolute top-0 bottom-0 w-0.5 bg-gray-500"
                      style={{
                        left: `${(totalRow.target / totalRow.average) * 100}%`,
                      }}
                    >
                      <div className="absolute -top-1 -left-1 w-2 h-2 rounded-full bg-gray-500" />
                    </div>
                  )}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default StagePerformanceCards;
